export default __webpack_public_path__ + "static/media/argentan3.043f69f5.jpg";